import axios from "axios";

const base = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": "en",
    "x-skyytask-platform": "ipad",
    "x-skyytask-version": "1.0.0",
    "accept": "application/json",
    "x-skyytask-device": "1",
  },
});

base.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = token;
  }
  return config;
});

base.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response.status === 401) {
    localStorage.clear();
    window.location.href = process.env.REACT_APP_BASENAME
  }
  return error;
});

export default base;
